// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.highlight[data-v-20743668] {\n  font-weight: bold;\n  font-size: 16px;\n}\n.orange[data-v-20743668] {\n  color: #e6a23c;\n}\n.blue[data-v-20743668] {\n  color: #409eff;\n}\n.green[data-v-20743668] {\n  color: #67c23a;\n}\n.mt14[data-v-20743668] {\n  margin-top: 14px;\n}\n.detail-container[data-v-20743668] {\n  padding: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
